import MasterBoundary from './MasterBoundary'

export default MasterBoundary
